//      
import {               } from 'css-box-model';
import { invariant } from '../../invariant';
             
                     
             
                   
                     
import { negate, subtract } from '../position';
import getSubject from './util/get-subject';

export default (
  droppable                    ,
  newScroll          ,
)                     => {
  invariant(droppable.frame);
  const scrollable             = droppable.frame;

  const scrollDiff           = subtract(newScroll, scrollable.scroll.initial);
  // a positive scroll difference leads to a negative displacement
  // (scrolling down pulls an item upwards)
  const scrollDisplacement           = negate(scrollDiff);

  // Sometimes it is possible to scroll beyond the max point.
  // This can occur when scrolling a foreign list that now has a placeholder.

  const frame             = {
    ...scrollable,
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement,
      },
      // TODO: rename 'softMax?'
      max: scrollable.scroll.max,
    },
  };

  const subject                   = getSubject({
    page: droppable.subject.page,
    withPlaceholder: droppable.subject.withPlaceholder,
    axis: droppable.axis,
    frame,
  });
  const result                     = {
    ...droppable,
    frame,
    subject,
  };
  return result;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/droppable/scroll-droppable.js